import { render, staticRenderFns } from "./filter-visa-type.vue?vue&type=template&id=2ae034ca&scoped=true"
import script from "./filter-visa-type.vue?vue&type=script&lang=js"
export * from "./filter-visa-type.vue?vue&type=script&lang=js"
import style0 from "./filter-visa-type.vue?vue&type=style&index=0&id=2ae034ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae034ca",
  null
  
)

export default component.exports